import * as React from "react";

import "./image-selector.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";
import {Responsive}     from "@Common/ui-components/responsive";
import {chain}          from "@Common/utils/fs";

import {TemplateSvgThumbnail}   from "@Xpresso/routes/common/components/template-svg-thumbnail/template-svg-thumbnail";
import {ImageZoom}              from "@Xpresso/routes/customize/steps/product-options/template-selection-template-view/front-template-viewer/image-viewer/image-zoom/image-zoom";

import {Thumbnails} from "./thumbnails/thumbnails";

export const ImageSelector = ({size, images, onEnlarge, onMore, getLastSelected}) => cs(
    consumeContext("svgThumbnailsCache"),
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ["maxThumbnailCount", ({responsive}, next) => next(responsive.lt("mobile") ? (
        size?.width > 172 ? chain(
            size.width,
            (width) => Math.floor(width / 86) - 1,
            (count) => Math.min(count, images.length),
        ) : 1
    ) : (
        size?.height > 185 ? chain(
            size.height,
            (height) => Math.floor((height - 69) / 58) - 1,
            (count) => Math.min(count, images.length),
        ) : 1
    ))],
    ["lastSelected", (_, next) => next(getLastSelected())],
    ["thumbnailHelper", ({maxThumbnailCount, lastSelected}, next) => next(getThumbnailHelper({maxThumbnailCount, lastSelected, images}))],
    ["selectedIndex", ({lastSelected}, next) => next(images.findIndex(img => img.id === lastSelected))],
    ["startIndex", ({maxThumbnailCount, thumbnailHelper: {outOfRange, endOfArray}, selectedIndex}, next) => next(
        outOfRange ? (
            endOfArray ? (
                images.length - maxThumbnailCount
            ) : (
                selectedIndex
            )
        ) : (
            0
        )
    )],
    ["endIndex", ({maxThumbnailCount, thumbnailHelper: {outOfRange, endOfArray}, selectedIndex}, next) => next(
        outOfRange ? (
            endOfArray ? (
                images.length - 1
            ) : (
                selectedIndex + maxThumbnailCount - 1
            )
        ) : (
            maxThumbnailCount - 1
        )
    )],
    ["img", (_, next) => next(images?.find((img) => img.selected))],
    ["imgSvgCodeLoad", ({img, svgThumbnailsCache}, next) => (
        Load2({next, _key: img?.id, fetch: async () => (
            img?.src.endsWith(".svg")
            ? svgThumbnailsCache.loadUrl(img.src)
            : null
        )})
    )],
    ({endIndex, img, imgSvgCodeLoad, maxThumbnailCount, responsive, startIndex}) => (
        responsive.lt("mobile") ? (
            <div className="image-selector image-selector-56s">
                <div className="body">
                    <div className="large">
                        <div className="img">
                            <img src={img?.src} alt="Front Thumbnail"/>
                        </div>
                        <div className="footer">
                            <div className="left">
                                {img?.details}
                            </div>
                        </div>
                    </div>
                    {images?.length > 1 && Thumbnails({images, onMore, maxThumbnailCount, startIndex, endIndex})}
                </div>
            </div>
        ) : (
            <div className="image-selector image-selector-56s">
                <div className="header">
                    <div className="title" xd-qa-type="label" xd-qa-name="Available Back">
                        {images.length > 1 ? ("Available Backs") : ("Available Back")}
                    </div>
                    <div className="count">
                        {`${startIndex+1} - ${endIndex+1} of ${images.length}`}
                    </div>
                </div>
                <div className="body">
                    {images?.length > 1 && Thumbnails({images, onMore, maxThumbnailCount, startIndex, endIndex})}
                    <div className="large">
                        <div className={`img ${imgSvgCodeLoad.loading ? "loading" : ""}`}><ImageZoom
                            renderImage={() => imgSvgCodeLoad.value ? (
                                <TemplateSvgThumbnail svgCode={imgSvgCodeLoad.value}/>
                            ) : (
                                <img
                                    src={img?.src}
                                    alt="Front Thumbnail"
                                    xd-qa-type="Image"
                                    xd-qa-name="Front Thumbnail"
                                />
                            )}
                        /></div>

                        <div className="footer">
                            <div className="left">
                                {img?.details}
                            </div>
                            <div className="right">
                                <div
                                    className="enlarge"
                                    onClick={onEnlarge}
                                    xd-qa-type="button"
                                    xd-qa-name="Click to Enlarge"
                                >
                                    <i className="fa fa-search"/>
                                    <div className="text">
                                        Click to Enlarge
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    ),
);
const getThumbnailHelper = ({maxThumbnailCount, lastSelected, images}) => {
    return {
        outOfRange: maxThumbnailCount > 0 && images.findIndex(img => img.id === lastSelected) >= maxThumbnailCount,
        endOfArray: images?.findIndex(img => img.id === lastSelected) + maxThumbnailCount > images.length
    };
}

